export default "__VITE_ASSET__BdMckX6m__"